import React from 'react';
import {DesktopView} from '../../../esiaRegCard/components/map/web/DesktopView';
import {MobileView} from '../../../esiaRegCard/components/map/web/MobileView';
import {useIsDesktop} from '../../../../../shared/hooks/useIsDesktop';
import {IssuePointSelectionMapProps} from './models';

export function IssuePointSelectionMap({
  mapCenterPoint,
  currentMarker,
  mapData,
  mapLoading,
  onIssuePointSelected,
  mapZoomLevel,
  isIssuePointDetailsVisible,
  setIsIssuePointDetailsVisible,
  markers,
  embeddedInModal,
}: IssuePointSelectionMapProps) {
  const isDesktop = useIsDesktop();
  const useDesktopMap = isDesktop || !!embeddedInModal;

  const mapProps = {
    mapData,
    onPressMarker: onIssuePointSelected,
    currentMarker,
    centerPoint: mapCenterPoint,
    zoomLevel: mapZoomLevel,
    isIssuePointDetailsVisible,
    setIsIssuePointDetailsVisible,
  };

  if (useDesktopMap) {
    return <DesktopView {...mapProps} markers={markers} />;
  }

  return <MobileView {...mapProps} loading={mapLoading} />;
}
